import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import { ROUTES } from '../utils/constants';
import LoadingSpinner from './LoadingSpinner';

/**
 * Wraps routes that require authentication.
 * - If not authenticated → redirect to /login
 * - If authenticated but no username → redirect to /register
 * - If loading → show spinner
 */
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, needsRegistration, loading } = useAuthContext();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (needsRegistration && location.pathname !== ROUTES.REGISTER) {
    return <Navigate to={ROUTES.REGISTER} replace />;
  }

  return children;
}
